import { makeStyles } from '@mui/styles'
import {
  FinanceCalculatorTheme,
  FcAccordionElementClasses,
} from '@dxp-module/themes'

const accordionElementStyles = makeStyles<
  FinanceCalculatorTheme,
  object,
  FcAccordionElementClasses
>(
  () => ({
    breakdownPrice: {
      flex: 1,
      textAlign: 'right',
    },
    breakdownSectionSummary: {
      borderTop: 0,
      fontWeight: 400,
      padding: '0 30px',
    },
    repaymentAmount: {
      fontWeight: 'inherit',
    },
  }),
  { name: 'FC_AccordionElement' }
)

export default accordionElementStyles
